import { ReactNode } from 'react';
import { CoreBox, CoreTypography } from '@youscience/core';

import ChevronRight from '@images/chevron-right.svg?react';

import {
  sxStyles,
  StyledOpportunityCardWrap,
  StyledOpportunitiesContent,
  StyledActionButton,
} from './EducationOpportunityCard.styles';

interface EmptyStateTextProps {
  icon: ReactNode;
  title: string;
  description: string;
  favoriteCount: number;
  favoriteLink: string;
  startExploringLink: string;
}

export const EducationOpportunityCard = (props: EmptyStateTextProps) => {
  const { icon, title, description, favoriteCount, favoriteLink, startExploringLink } = props;

  return (
    <StyledOpportunityCardWrap>
      {icon}

      <StyledOpportunitiesContent>
        <CoreBox>
          <CoreTypography sx={sxStyles.title} variant="h5">
            {title}
          </CoreTypography>

          <CoreTypography sx={sxStyles.description} variant="body2">
            {description}
          </CoreTypography>
        </CoreBox>

        <CoreBox sx={sxStyles.buttonsWrap}>
          <StyledActionButton data-testid="favoriteLink" to={favoriteLink}>
            {` Go to favorites (${favoriteCount})`}

            <ChevronRight />
          </StyledActionButton>

          <CoreBox sx={sxStyles.divider} />

          <StyledActionButton data-testid="startExploringLink" to={startExploringLink}>
            Start exploring
            <ChevronRight />
          </StyledActionButton>
        </CoreBox>
      </StyledOpportunitiesContent>
    </StyledOpportunityCardWrap>
  );
};
